<div class="filter-search-sidebar-wrapper">

  <div class="filter-search-sidebar-content">
    
  </div>  

</div>